import { IconButton } from '@mui/material';

import { Box } from '@mui/material';

type CellActionsProps = {
  children: React.ReactNode;
};

const CellActions = ({ children }: CellActionsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        opacity: 0,
        transition: 'opacity 0.2s',
        '.MuiDataGrid-row:hover &': {
          opacity: 1,
        },
      }}>
      {children}
    </Box>
  );
};

export { CellActions };
export type { CellActionsProps };
